import axios from 'axios'

class Sellers {
  async list (filter) {
    const url = `${process.env.ACCOUNT_API_URL}/sellers?`
    var queryStringElements = 0

    const taxDocument = (filter.taxDocument === '' ? `` : `${queryStringElements !== 0 ? '&' : ''}taxDocument=${filter.taxDocument}`)
    if (filter.taxDocument !== '') {
      queryStringElements++
    }
    const fullName = (filter.fullName === '' ? `` : `${queryStringElements !== 0 ? '&' : ''}fullName=${filter.fullName}`)
    if (filter.fullName !== '') {
      queryStringElements++
    }
    const email = (filter.email === '' ? `` : `${queryStringElements !== 0 ? '&' : ''}email=${filter.email}`)
    if (filter.email !== '') {
      queryStringElements++
    }
    const offset = `${queryStringElements !== 0 ? '&' : ''}index=${filter.offset.index}&${filter.offset.limit}`
    const result = await axios.get(`${url}${taxDocument}${fullName}${email}${offset}`)

    return result.data
  }

  async find (holderId) {
    const url = `${process.env.ACCOUNT_API_URL}/sellers/${holderId}`
    const result = await axios.get(url)

    return result.data
  }
}

export default class AccountApi {
  sellers = new Sellers()

  async signin (username, password) {
    const url = `${process.env.ACCOUNT_API_URL}/${process.env.APPLICATION_ID}/signin`
    const model = { login: username, password: password }
    const result = await axios.post(url, model)

    return result
  }

  async signinAs (holderId) {
    const url = `${process.env.ACCOUNT_API_URL}/signin-as/${holderId}`
    const result = await axios.post(url)
    return result
  }

  async whoAmI () {
    const result = await axios.get(`${process.env.ACCOUNT_API_URL}/whoami`, {})
    return result.data
  }
}



// WEBPACK FOOTER //
// ./src/services/AccountApi.js